module.exports = __webpack_public_path__ + "img/easysooqlogo.41212070.png";